// extracted by mini-css-extract-plugin
export default {"icon":"RecurringCost_icon__AticJ","value":"RecurringCost_value__xcb4p"};